import AxiosRequest from './AxiosRequest';

export default class Announcement {
    
    index() {
        return new AxiosRequest().get(`announcements`)
    }

}